// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-foot {
  display: none;
}

.sr-only {
  display: none;
}

.react-bs-table-no-data {
  text-align: center;
}

.export-container {
  text-align: end;
}
.search-student {
  display: grid;
}

.search-result {
  margin-top: 10px;
}

.rank-custom-cell {
  width: 8%;
}

.number-custom-cell {
  width: 4%;
}

.manage-container {
  /* display: flex;
    justify-content: end;
    margin-bottom: 10px;
    align-items: center; */
  margin: 20px 40px;
}

.sort-text {
  margin-top: 10px;
}

.fa-spin {
  margin-right: 5px;
}

.not-qualified {
  background-color: #ffb2b2;
}

.soft-qualified {
  background-color: #ffecb5;
}

.fetch-student {
  margin-left: 5px;
}

.btn-clear-student {
  margin-left: 5px;
}

.btn-warning {
  margin-left: 5px;
}

.react-tabs__tab-list {
  display: flex;
}

.btn-approve-student {
  margin-left: 5px;
}

.info-footer {
  margin-top: 60px;
}

.label-sign-name {
  margin-top: 10px;
}

.info-footer .label-studentcourse-approve-at {
  float: right;
}

.info-footer .label-sign {
  float: left;
}

.sort-student {
  margin-right: 5px;
}
.print-sort-student {
  margin-left: 5px;
}
.tool-admin-btn {
  margin-left: 5px;
}
.setting-container {
  width: 100%;
}
.fetch-students-at-container {
  float: right;
  margin-right: 18px !important;
}
.btn-right-container {
  display: flex;
  justify-content: end;
}
.fetch-data-btn {
  margin-right: 5px;
}
.import-data-btn {
  margin-right: 5px;
}
.sort-btn-container {
  padding: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/StudentCourse/StudentCourse.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;;;0BAGwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".table-foot {\n  display: none;\n}\n\n.sr-only {\n  display: none;\n}\n\n.react-bs-table-no-data {\n  text-align: center;\n}\n\n.export-container {\n  text-align: end;\n}\n.search-student {\n  display: grid;\n}\n\n.search-result {\n  margin-top: 10px;\n}\n\n.rank-custom-cell {\n  width: 8%;\n}\n\n.number-custom-cell {\n  width: 4%;\n}\n\n.manage-container {\n  /* display: flex;\n    justify-content: end;\n    margin-bottom: 10px;\n    align-items: center; */\n  margin: 20px 40px;\n}\n\n.sort-text {\n  margin-top: 10px;\n}\n\n.fa-spin {\n  margin-right: 5px;\n}\n\n.not-qualified {\n  background-color: #ffb2b2;\n}\n\n.soft-qualified {\n  background-color: #ffecb5;\n}\n\n.fetch-student {\n  margin-left: 5px;\n}\n\n.btn-clear-student {\n  margin-left: 5px;\n}\n\n.btn-warning {\n  margin-left: 5px;\n}\n\n.react-tabs__tab-list {\n  display: flex;\n}\n\n.btn-approve-student {\n  margin-left: 5px;\n}\n\n.info-footer {\n  margin-top: 60px;\n}\n\n.label-sign-name {\n  margin-top: 10px;\n}\n\n.info-footer .label-studentcourse-approve-at {\n  float: right;\n}\n\n.info-footer .label-sign {\n  float: left;\n}\n\n.sort-student {\n  margin-right: 5px;\n}\n.print-sort-student {\n  margin-left: 5px;\n}\n.tool-admin-btn {\n  margin-left: 5px;\n}\n.setting-container {\n  width: 100%;\n}\n.fetch-students-at-container {\n  float: right;\n  margin-right: 18px !important;\n}\n.btn-right-container {\n  display: flex;\n  justify-content: end;\n}\n.fetch-data-btn {\n  margin-right: 5px;\n}\n.import-data-btn {\n  margin-right: 5px;\n}\n.sort-btn-container {\n  padding: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
